import * as React from 'react';
import * as style from './style.css';
import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorScreen = function ErrorScreen(_ref) {
  var onRetry = _ref.onRetry;
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    children: /*#__PURE__*/_jsxs("div", {
      className: style['container-inner'],
      children: [/*#__PURE__*/_jsx("div", {
        className: style['image']
      }), /*#__PURE__*/_jsxs("div", {
        className: style['controls'],
        children: [/*#__PURE__*/_jsx(UIHeading1, {
          textAlign: "center",
          children: "\u0427\u0442\u043E-\u0442\u043E\xA0\u043F\u043E\u0448\u043B\u043E \u043D\u0435\xA0\u0442\u0430\u043A"
        }), /*#__PURE__*/_jsxs(UIText1, {
          textAlign: "center",
          children: ["\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 ", /*#__PURE__*/_jsx("br", {}), "\u0438\u043B\u0438\xA0\u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"]
        }), /*#__PURE__*/_jsx(Button, {
          size: "L",
          onClick: onRetry,
          children: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"
        })]
      })]
    })
  });
};